import { render, staticRenderFns } from "./PosicaoAtual.vue?vue&type=template&id=7306b21f"
import script from "./PosicaoAtual.vue?vue&type=script&lang=js"
export * from "./PosicaoAtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports